<template>
  <div class="questionnaire mt-1">
    <ul class="question-numbers">
      <li
        v-for="question in exam.questions"
        :key="question.index"
        :class="{ active: question.selected, answered: question.answered }"
        class="number-border"
        @click="select(question)"
      >
        <div
          class="number" :class="{ answered: question.answered }"
          v-html="question.index"
        />
      </li>
    </ul>

    <div class="question box mt-2 mb-1 has-greyish-background">
      <div v-html="current.question" />
    </div>

    <ul class="answers mt-2 ml-2 mr-2">
      <li
        :class="{ chosen: current.student_answer === 'A' }"
        class="answer"
        @click="choose('A')"
      >
        <div class="is-flex">
          <div class="is-flex is-align-items-center check-mark-column">
            <span v-if="current.student_answer === 'A'" class="check-mark">
              ✓
            </span>
          </div>
          <div style="flex: 1;">
            <span v-html="current.A" />
          </div>
        </div>
      </li>
      <li
        :class="{ chosen: current.student_answer === 'B' }"
        class="answer"
        @click="choose('B')"
      >
        <div class="is-flex">
          <div class="is-flex is-align-items-center check-mark-column">
            <span v-if="current.student_answer === 'B'" class="check-mark">
              ✓
            </span>
          </div>
          <div style="flex: 1;">
            <span v-html="current.B" />
          </div>
        </div>
      </li>
      <li
        :class="{ chosen: current.student_answer === 'C' }"
        class="answer"
        @click="choose('C')"
      >
        <div class="is-flex">
          <div class="is-flex is-align-items-center check-mark-column">
            <span v-if="current.student_answer === 'C'" class="check-mark">
              ✓
            </span>
          </div>
          <div style="flex: 1;">
            <span v-html="current.C" />
          </div>
        </div>
      </li>
    </ul>

    <div class="columns is-multiline mt-5">
      <div class="column is-6">
        <button
          v-if="current.index > 1"
          class="button is-primary is-medium is-full-width-touch"
          @click="selectPrevious"
          v-html="$t('pagination.previous')"
        />
      </div>
      <div class="column is-6 is-right">
        <button
          v-if="current.index < exam.questions.length"
          class="button is-primary is-medium is-full-width-touch"
          @click="selectNext"
          v-html="$t('pagination.next')"
        />
      </div>
      <div class="column is-12 is-centered">
        <button
          class="button is-danger is-medium is-full-width-touch"
          @click="complete"
          v-html="$t('exam.submit-answers')"
        />
      </div>
    </div>
  </div>
</template>

<style>
  .check-mark-column {
    flex: 0 0 auto;
    width: 40px;
  }
</style>

<script>
import { every, find } from 'lodash';

export default {
  name: 'Questionnaire',

  props: {
    exam: { type: Object, required: true }
  },

  data() {
    const q = _.first(this.exam.questions);
    q.selected = true;

    return {
      cc: q
    };
  },

  computed: {
    current() {
      return find(this.exam.questions, q => q.selected);
    },

    hasUnansweredQuestions() {
      return !every(this.exam.questions, 'answered');
    }
  },

  methods: {
    select(question) {
      this.exam.questions.forEach(q => {
        q.selected = false;

        if (q.id === question.id) {
          q.selected = true;
        }
      });
    },

    selectNext() {
      this.select(
        find(this.exam.questions, q => this.current.index + 1 === q.index),
      );
    },

    selectPrevious() {
      this.select(
        find(this.exam.questions, q => this.current.index - 1 === q.index),
      );
    },

    choose(answerLetter) {
      this.current.student_answer = answerLetter;
      this.current.answered = true;
      this.$emit('answered', this.current);
    },

    complete() {
      let message = this.$t('exam.confirm-completion');

      if (this.hasUnansweredQuestions) {
        message = `
            ${this.$t('exam.you-have-unanswered-questions')} <br/>
            ${this.$t('exam.confirm-completion')}
        `;
      }

      Swal.fire({
        type: 'warning',
        html: message,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.$emit('complete');
        }
      });
    }
  }
};
</script>
